module.exports = __webpack_public_path__ + "img/randomimage (1).a7c22f4f.png";